import request from '@/utils/request'

export function fetchCardGiftList (query) {
  return request({
    url: '/card/api/card_gift/index',
    method: 'get',
    params: query
  })
}

export function createCardGift (data) {
  return request({
    url: '/card/api/card_gift/insert',
    method: 'post',
    data
  })
}

export function updateCardGift (data) {
  return request({
    url: '/card/api/card_gift/update',
    method: 'post',
    data
  })
}

export function deleteCardGift (id) {
  return request({
    url: '/card/api/card_gift/delete',
    method: 'post',
    params: { id }
  })
}



// WEBPACK FOOTER //
// ./src/card/api/card-gift.js